import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

export default function LakeMakeupTable(props) {
  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>Permit Number</TableCell>
          <TableCell>Permittee</TableCell>
          <TableCell>Well</TableCell>
          <TableCell>Allocation</TableCell>
          <TableCell>Alt Water</TableCell>
          <TableCell>TWD</TableCell>
          <TableCell>Notes</TableCell>
          <TableCell>Area</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.permits.length === 0 ? (
          <Typography variant='h6'>None</Typography>
        ) : (
          props.permits.map((permit, i) => (
            <TableRow key={i}>
              <TableCell>{permit.CASE_NUMBER}</TableCell>
              <TableCell>{permit.Permittee}</TableCell>
              <TableCell>{permit.WellNo}</TableCell>
              <TableCell>{permit.Allocation}</TableCell>
              <TableCell>{permit.altwtr}</TableCell>
              <TableCell>
                {Number.parseFloat(permit.Allocation + permit.altwtr).toFixed(
                  2
                )}
              </TableCell>
              <TableCell>{permit.DistPlanComp}</TableCell>
              <TableCell>{permit.AREA}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
